import { useUser } from "../contexts/userContext/userContext.js";
import { useMail } from "../contexts/mailContext/mailContext.js";
import useMailSender from "./useMailSender.js";
import { useAdblockDetector } from "react-adblock-detector";
import useMediaQueries from "./useMediaQueries.js";
import { useContent } from "contexts/contentContext/contentContext.js";

export const useAdblockerModal = () => {
  const [isAdblockerDetected, isAdblockCheckComplete] = useAdblockDetector();
  const { mobileCondition } = useMediaQueries();
  const { getMailMetaData } = useMail();
  const { getBasicSettingsData } = useContent();
  const { isMailSenderHasBusinessSubscription } = useMailSender();
  const { isSubscribed } = useUser();
  const userSubscriber = isSubscribed();
  const ownerSubscriber = isMailSenderHasBusinessSubscription;
  const amountOfDownloads = getBasicSettingsData()?.DisplayAdBlockModalDownloads;
  const mailOver35Downloads = getMailMetaData()?.UniqueDownloadCount > amountOfDownloads;
  const detectedAdblocker = isAdblockerDetected;

  const displayAdblockerModal =
    mailOver35Downloads &&
    !userSubscriber &&
    !ownerSubscriber &&
    detectedAdblocker &&
    !mobileCondition &&
    isAdblockCheckComplete;
  return displayAdblockerModal;
};
